import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import ReactSelect from "react-select";
import { toast } from "react-toastify";
import {
  getCitiesByState,
  getInput,
  getLocalityByState,
  getmarketsByState,
  getStates,
} from "../../../api";
import { api_url } from "../../../constant";
import background from "../../../images/background.png";

import { getInputsCategories } from "../../../api";
import AppBar from "../../../components/appBar";
import Client from "../../../utils/client";
import ReactGA from "react-ga4";

function AddInput({ type, isEdit = false }) {
  if (type === "sell") {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: "Add Input Offer",
    });
  } else {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: "Add Input Order",
    });
  }
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    watch,
    reset,
  } = useForm();

  let { id } = useParams();

  const { data: categories } = useQuery({
    queryKey: ["inputsCategories"],
    queryFn: () => getInputsCategories(),
    initialData: [],
  });
  const { data: states } = useQuery({
    queryKey: ["states"],
    queryFn: () => getStates(),
    initialData: [],
  });

  const { data: cities, refetch: citiesRefetch } = useQuery({
    queryKey: ["cities"],
    queryFn: () => getCitiesByState(getValues().state.value),
    initialData: [],
    enabled: false,
  });

  const { data: markets, refetch: marketRefetch } = useQuery({
    queryKey: ["markets"],
    queryFn: () => getmarketsByState(getValues().state.value),
    initialData: [],
    enabled: false,
  });

  const { data: locality, refetch: localityRefetch } = useQuery({
    queryKey: ["locality"],
    queryFn: () => getLocalityByState(getValues().state.value),
    initialData: [],
    enabled: false,
  });

  const { } = useQuery({
    queryKey: ["input"],
    queryFn: () => getInput(id),
    enabled: isEdit,
    onSuccess: (data) => {
      reset({
        state: { label: data._state.name, value: data._state.id },
        city: { label: data._city.name, value: data._city.id },
        locality: data._locality
          ? { label: data._locality.name, value: data._locality.id }
          : null,
        market: data._market
          ? { label: data._market.name, value: data._market.id }
          : null,
        name: data.name,
        description: data.description,
        category_id: {
          label: data.input_category.name,
          value: data.input_category.id,
        },
        price: data.price,
        ingredients: data.ingredients,
        application: data.application,
        dose: data.dose,
        cautions: data.cautions,
        storing: data.storing,
        quality_certificate: data.quality_certificate,
      });
    },
  });

  const onSubmit = (data) => post(data);

  const post = async (data) => {
    if (!data.category_id || !data.category_id.value) {
      toast("يرجى اختيار المدخل", { type: "error" });
      return;
    }
    if (!data.state || !data.state.value) {
      toast("يرجى اختيار الولاية", { type: "error" });
      return;
    }
    if (!data.locality || !data.locality.value) {
      toast("يرجى اختيار المحلية ", { type: "error" });
      return;
    }
    const _data = JSON.stringify({
      category_id: data.category_id?.value,
      name: data.name,
      description: data.description,
      locality: data.locality?.value.toString() || null,
      // city: data.city.value.toString(),
      market: data.market?.value.toString() || null,
      state: data.state?.value.toString(),
      price: data.price || null,
      ingredients: data.ingredients,
      application: data.application,
      dose: data.dose,
      cautions: data.cautions,
      storing: data.storing,
      quality_certificate: data.quality_certificate,
      type,
    });
    try {
      let response;
      if (isEdit) {
        response = await Client.post(api_url + `/inputs/edit/${id}`, _data, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
      } else {
        response = await Client.post(api_url + "/inputs", _data, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
      }

      // Check if the offer was created/updated successfully
      if (response.data && response.data.id) {
        console.log('response', response);
        const inputId = response.data.id; // Get the offer ID from the response

        // Upload images if any
        if (images.length > 0) {
          await uploadFiles(inputId);
        }

        // Redirect or show success message
        toast("تم إنشاء العرض بنجاح", { type: "success" });
        window.history.go(-1); // Navigate back
      } else {
        throw new Error("فشل في إنشاء العرض");
      }
    } catch (error) {
      console.error("Error:", error);
      toast("الرجاء التأكد من البيانات", { type: "error" });
    }
  };

  const sold = async () => {
    await Client.post(
      api_url + `/inputs/edit/${id}`,
      JSON.stringify({ status: "sold" }),
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    )
      .then((res) => window.history.go(-1))
      .catch((e) => toast("الرجاء التأكد من البيانات", { type: "error" }));
  };
  const [images, setImages] = useState([]);
  const [media, setMedia] = useState([]);
  // Handle file upload
  const handleImageUpload = (file) => {
    if (file) {
      // Check file size (10 MB limit)
      const maxSizeMB = 10;
      if (file.size > maxSizeMB * 1024 * 1024) {
        toast.error(`حجم الملف يتجاوز ${maxSizeMB} ميجابايت`);
        return;
      }

      // Check number of files (maximum of 5)
      if (images.length >= 5) {
        toast.error("يمكنك تحميل حتى 5 ملفات فقط");
        return;
      }

      setImages((prevFiles) => {
        if (prevFiles.length < 5) {
          return [...prevFiles, file];
        }
        return prevFiles;
      });
      const fileReader = new FileReader();
      fileReader.onload = (e) => {
        setMedia((prevMedia) => [...prevMedia, e.target.result]);
      };
      fileReader.readAsDataURL(file);
    }
  };
  const uploadFiles = async (offerId) => {
    const formData = new FormData();
    images.forEach((image, index) => {
      formData.append("images", image);
    });

    // Log FormData contents
    for (let [key, value] of formData.entries()) {
      console.log(key, value);
    }

    try {
      const response = await fetch(`${api_url}/files/upload-images/input/${offerId}`, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      const result = await response.json();

      if (response.status > 201) {
        throw new Error(result.message || "فشل في تحميل الصور");
      }

      toast("تم تحميل الصور بنجاح", { type: "success" });
    } catch (error) {
      console.error("Error uploading files:", error);
      console.error("Images:", images);
      toast("فشل في تحميل الصور", { type: "error" });
    }
  };
  // Handle file removal (optional)
  const removeImage = (index) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  return (
    <div className="items-center  justify-center w-screen h-screen overflow-x-hidden">
      <AppBar key="4" />
      <div className="h-10" />
      <div className="flex flex-row justify-between px-40 font-bold text-primary text-[18px]">
        <div
          className="flex justify-center items-center"
          onClick={() => window.history.go(-1)}
        >
          <svg
            className="w-7 text-primary"
            fill="none"
            stroke="currentColor"
            strokeWidth={1.5}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15.75 19.5L8.25 12l7.5-7.5"
            />
          </svg>
          <p>عودة </p>
        </div>
        <div className="text-black">{isEdit ? "تعديل" : "إضافة"}</div>
      </div>
      <div className="h-10"></div>
      <div className="flex flex-col">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="flex flex-col items-center justify-center"
        >
          <div className="flex flex-col w-2/6">
            <ReactSelect
              className="border-primary border-[1px] rounded-md"
              options={categories.map((e) => {
                return { label: e.name, value: e.id };
              })}
              value={getValues().category_id}
              onChange={(value) =>
                reset({ ...getValues(), category_id: value })
              }
              hideSelectedOptions={false}
              closeMenuOnSelect={true}
              isRtl
              placeholder={
                <span className="font-bold after:content-['*'] after:mr-1 after:text-red-500 ">
                  المدخل
                </span>
              }
            />
          </div>
          <div className="h-5" />

          <div className="flex flex-col-reverse lg:flex-row lg:gap-5 w-full justify-center items-center">
            {/* <div className="flex flex-col w-2/6 lg:w-1/6">
              <ReactSelect
                className="border-primary border-[1px] rounded-md"
                options={cities.map((e) => {
                  return { label: e.name, value: e.id };
                })}
                value={getValues().city}
                onChange={(value) => reset({ ...getValues(), city: value })}
                hideSelectedOptions={false}
                closeMenuOnSelect={true}
                isRtl
                placeholder={
                  <span className="font-bold after:content-['*'] after:mr-1 after:text-red-500 ">
                    المدينة
                  </span>
                }
                isDisabled={cities.length === 0}
              />
            </div> */}

            <div className="h-5" />

            <div className="flex flex-col w-2/6 lg:w-1/6">
              <ReactSelect
                className="border-primary border-[1px] rounded-md"
                options={states.map((e) => {
                  return { label: e.name, value: e.id };
                })}
                value={getValues().state}
                onChange={(value) => {
                  setValue("state", value);
                  citiesRefetch();
                  marketRefetch();
                  localityRefetch();
                }}
                hideSelectedOptions={false}
                closeMenuOnSelect={true}
                isRtl
                placeholder={
                  <span className="font-bold after:content-['*'] after:mr-1 after:text-red-500 ">
                    الولاية
                  </span>
                }
              />
            </div>
          </div>
          <div className="h-5" />

          <div className="flex flex-col lg:flex-row lg:gap-5 w-full justify-center items-center">
            <div className="flex flex-col w-2/6 lg:w-1/6">
              <ReactSelect
                className="border-primary border-[1px] rounded-md"
                options={markets.map((e) => {
                  return { label: e.name, value: e.id };
                })}
                value={getValues().market}
                onChange={(value) => reset({ ...getValues(), market: value })}
                hideSelectedOptions={false}
                closeMenuOnSelect={true}
                isRtl
                placeholder="السوق"
                isDisabled={markets.length === 0}
              />
            </div>

            <div className="h-5" />

            <div className="flex flex-col w-2/6 lg:w-1/6">
              <ReactSelect
                className="border-primary border-[1px] rounded-md"
                options={locality.map((e) => {
                  return { label: e.name, value: e.id };
                })}
                value={getValues().locality}
                onChange={(value) => {
                  reset({ ...getValues(), locality: value });
                }}
                hideSelectedOptions={false}
                closeMenuOnSelect={true}
                isRtl
                isDisabled={locality.length === 0}
                placeholder="المحلية"
              />
            </div>
          </div>

          <div className="h-5" />
          <input
            {...register("name", { required: true })}
            dir="rtl"
            className="border h-10  px-2 mb-5 rounded-md w-96 border-primary"
            placeholder="إسم المنتج"
          />

          <textarea
            {...register("description", { required: true })}
            className="border-[1px] h-32 resize-none p-3 mb-5 rounded-md w-96 break-words border-primary"
            multiple
            placeholder="الوصف"
            dir="rtl"
          />
          {type === "sell" && (
            <>
              <div className="flex w-[45%] gap-5">
                <textarea
                  {...register("ingredients")}
                  dir="rtl"
                  className="border h-14  resize-none  px-2 mb-5 rounded-md w-[50%] border-primary"
                  placeholder="مكونات المنتج (إختياري)"
                />
                <textarea
                  {...register("application")}
                  dir="rtl"
                  className="border h-14  px-2 resize-none mb-5 rounded-md w-[50%] border-primary"
                  placeholder="كيفية الإستخدام  (إختياري)"
                />
              </div>

              <div className="flex w-[45%] gap-5">
                <textarea
                  {...register("dose")}
                  dir="rtl"
                  className="border h-14  resize-none  px-2 mb-5 rounded-md w-[50%] border-primary"
                  placeholder=" الجرعة أو الكمية المناسبة (إختياري)"
                />
                <textarea
                  {...register("cautions")}
                  dir="rtl"
                  className="border h-14  px-2 resize-none mb-5 rounded-md w-[50%] border-primary"
                  placeholder=" إرشادات السلامة (إختياري)"
                />
              </div>

              <div className="flex w-[45%] gap-5">
                <textarea
                  {...register("storing")}
                  dir="rtl"
                  className="border h-14  resize-none  px-2 mb-5 rounded-md w-[50%] border-primary"
                  placeholder=" تواريخ الإستخدام والتخزين  (إختياري)"
                />
                <textarea
                  {...register("quality_certificate")}
                  dir="rtl"
                  className="border h-14  px-2 resize-none mb-5 rounded-md w-[50%] border-primary"
                  placeholder=" شهادة الجودة  (إختياري)"
                />
              </div>
              <input
                {...register("price", {
                  valueAsNumber: true,
                })}
                type="number"
                dir="rtl"
                className="border-2 h-12 p-3 mb-5 rounded-md w-96"
                placeholder="السعر"
              />
            </>
          )}
          <div className="h-5" />
          {type === "sell" && (
            <>
              < div className="w-96 h-[20vh] border-primary border-[1px] bg-gray-50 rounded-md flex justify-center items-center text-gray-500">
                <input
                  type="file"
                  id="file"
                  className="hidden"
                  onChange={(e) => handleImageUpload(e.target.files[0])}
                  accept="image/*" // Allow only image files
                />
                <label
                  htmlFor="file"
                  className="font-bold before:mr-1 before:text-red-500"
                >
                  إرفاق صور
                </label>
              </div>
              <div className="h-5" />

              <div className="flex flex-row gap-3">
                {media.length > 0 &&
                  media.map((src, index) => (
                    <div key={index} className="relative">
                      <img
                        src={src}
                        className="w-16 h-16 object-cover border border-gray-300 rounded"
                        alt="Preview"
                      />
                      <button
                        type="button"
                        className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center"
                        onClick={() => removeImage(index)}
                      >
                        ×
                      </button>
                    </div>
                  ))}
              </div>
            </>
          )}

          <button
            hidden={!isEdit}
            type="button"
            {...register("status")}
            className="border-2 h-12 p-3 mb-5 rounded-md w-60 bg-amber-600 text-white font-bold text-lg"
            value="تم البيع؟"
            onClick={() => sold()}
          >
            تم البيع؟
          </button>

          <input
            type="submit"
            className="h-12 bg-primary text-white rounded-md w-60"
            value={isEdit ? "تعديل" : "إضافة"}
          />
        </form>
      </div>
      <div className="fixed left-0 bottom-1 z-0">
        <img src={background} alt="" className="lg:w-[20vw] w-[50vw]" />
      </div>
    </div>
  );
}

export default AddInput;
